import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { navigate } from 'gatsby';
import ToggleButton from '../components/ToggleButton';
import SubListGroups from '../components/SubListGroups'; /* global __PATH_PREFIX__*/
var pathPrefix = __PATH_PREFIX__;
var ListItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ListItem, _React$Component);
  function ListItem(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      opened: _this.isSelected()
    };
    _this.toggleItemState = _this.toggleItemState.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ListItem.prototype;
  _proto.handleClick = function handleClick(ev) {
    ev.preventDefault();
    if (!this.isSelected()) {
      navigate("/" + this.props.pid);
    } else {
      this.toggleItemState();
    }
  };
  _proto.toggleItemState = function toggleItemState() {
    this.setState(function (prevState) {
      return {
        opened: !prevState.opened
      };
    });
  };
  _proto.isSelected = function isSelected() {
    var _this$props = this.props,
      selectedId = _this$props.selectedId,
      pid = _this$props.pid;
    return selectedId ? selectedId.split('#').shift() === pid : false;
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      selectedId = _this$props2.selectedId,
      pid = _this$props2.pid,
      name = _this$props2.name,
      childNodes = _this$props2.childNodes;
    var opened = this.state.opened;
    var hasChildNodes = !!(childNodes && childNodes.length);
    var selected = this.isSelected();
    return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("p", {
      className: "nav-item" + (selected ? ' selected' : '')
    }, /*#__PURE__*/React.createElement("a", {
      href: pathPrefix + "/" + pid,
      className: "ellipsis",
      onClick: this.handleClick
    }, /*#__PURE__*/React.createElement("span", null, name)), hasChildNodes && /*#__PURE__*/React.createElement(ToggleButton, {
      hasChildNodes: hasChildNodes,
      opened: opened,
      handleClick: this.toggleItemState
    })), hasChildNodes && /*#__PURE__*/React.createElement(SubListGroups, {
      selectedId: selectedId,
      hasChildNodes: hasChildNodes,
      opened: opened,
      items: childNodes
    }));
  };
  return ListItem;
}(React.Component);
export default ListItem;